exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".popup .header h2,.popup .head h2{color:#006fba!important}.popup .fancybox-close:after,.popup .fancybox-close:before{background:#006fba}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./dreamtown.scss
// module id = 123
// module chunks = 0